import React from 'react';

/**
 * Badge — TestCoachAI design system
 *
 * Inline status pill. Optionally shows a coloured dot before the label.
 *
 * Variants: default | primary | accent | success | danger | warning | premium | ink
 * Sizes:    sm | md | lg
 *
 * Usage:
 *   import { Badge } from '../ui';
 *   <Badge variant="success">Verified</Badge>
 *   <Badge variant="danger" dot>Incorrect</Badge>
 *   <Badge variant="premium" size="lg">Pro</Badge>
 *   <Badge variant="warning">Unverified</Badge>
 */
export function Badge({
  variant = 'default',
  size = 'md',
  dot = false,
  children,
  className = '',
  ...props
}) {
  const cls = ['tc-badge', `tc-badge--${variant}`, `tc-badge--${size}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={cls} {...props}>
      {dot && <span className="tc-badge__dot" aria-hidden="true" />}
      {children}
    </span>
  );
}
